import { useTranslation } from 'react-i18next';

import SelectField from 'components/forms/selectField/SelectField';
import { TriggerJobTiming } from 'models/automation/Triggers';
import { orderBy } from 'utils/arrayUtils';

const TriggerAddEditModalTimingField = () => {
  const { t } = useTranslation();

  const serviceOptions = Object.values(TriggerJobTiming).map((value) => {
    return {
      label: t('pageAutomations.triggers.jobTiming', { context: value }),
      value,
    };
  });

  const options = [
    { label: t('pageAutomations.triggers.jobTiming'), value: '' },
    ...orderBy(serviceOptions, [{ field: 'label', order: 'asc' }]),
  ];

  return (
    <SelectField
      colSmInput={12}
      label={t('pageAutomations.triggers.modal.jobTiming')}
      labelOnTop
      name="jobTiming"
      options={options}
      required
    />
  );
};

export default TriggerAddEditModalTimingField;
